import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import types from "./types";
import {
  Header,
  Title,
  TitleIconWrapper as IconWrapper
} from "./styled/ModalContent";

const headerIcons = {
  success: "fa-check-circle-o",
  danger: "fa-exclamation",
  warning: "fa-exclamation-triangle",
  info: "fa-info-circle"
};

const TitleIcon = ({ appearance }) => {
  const iconForAppearance = headerIcons[appearance] || "";

  return (
    <IconWrapper
      className={`fa fa-fw ${iconForAppearance} text-${appearance}`}
    />
  );
};

TitleIcon.propTypes = { appearance: types.appearance.isRequired };

class HeaderComponent extends PureComponent {
  static propTypes = {
    appearance: types.appearance,
    heading: PropTypes.string,
    icon: PropTypes.node
  };

  static defaultProps = {
    appearance: "primary",
    heading: null,
    icon: null
  };

  render() {
    const { heading } = this.props;
    // const isPrimary = appearance === "primary";

    if (!heading) {
      return null;
    }

    return (
      <Header>
        <Title>
          {/* {isPrimary ? icon : <TitleIcon appearance={appearance} />} */}
          {heading}
        </Title>
      </Header>
    );
  }
}

export default HeaderComponent;